import { Routes, Route } from "react-router-dom";
import GasoilPrices from "./GasoilPrices";
import GasoilPriceCreateEdit from "./GasoilPriceCreateEdit";

const index = () => {
	return (
		<Routes>
			<Route index element={<GasoilPrices />} />
			<Route path='/create' element={<GasoilPriceCreateEdit />} />
			<Route path='/:id/edit' element={<GasoilPriceCreateEdit />} />
		</Routes>
	);
};

export default index;
